import { API_URL } from '../../config/api';
import { createActionItemDocument, deleteActionItemDocument } from '../../api/documents';
import { DocumentAttachment } from '../common/DocumentAttachment';

interface ActionItemsDocumentAttachmentProps {
  projectId: string;
  itemId: string;
  documentUrl?: string | null;
  fileName?: string | null;
  onUpdate?: () => Promise<void>;
  onDocumentChange?: (documentUrl: string | undefined, fileName: string | undefined) => void;
}

export const ActionItemsDocumentAttachment = ({ projectId, itemId, documentUrl, fileName, onDocumentChange }: ActionItemsDocumentAttachmentProps) => (
  <DocumentAttachment
    recordLabel="action item"
    recordKey={`${projectId}-${itemId}`}
    documentUrl={documentUrl}
    fileName={fileName}
    onDocumentChange={onDocumentChange}
    adapter={{
      upload: (token, file) => createActionItemDocument(token, projectId, itemId, file),
      remove: (token) => deleteActionItemDocument(token, projectId, itemId),
      downloadUrl: (name) => `${API_URL}/action_items/${projectId}/items/${itemId}/document/${encodeURIComponent(name)}`,
    }}
  />
);
